import { atom } from 'jotai';
import { User } from '../../types/user.types';

export const user = atom<User | null>(null);  